import React from "react";
import { connect } from "react-redux";
import { getUserMe } from "ducks/user";
import { Button, Grid, IconButton, useMediaQuery } from "@material-ui/core";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
  useTheme,
} from "@material-ui/core/styles";
import ProfileButton from "components/ProfileButton";
import Icons from "components/Icon";
import Avatar from "@material-ui/core/Avatar";

const styles = (theme: Theme) =>
  createStyles({
    iconButtonAvatar: {
      padding: 4,
    },
  });

export type ProfileMenuProps = WithStyles<typeof styles> &
  ReturnType<typeof getUserMe>;

const Menu = (p: ProfileMenuProps) => {
  const { currentUser } = p;

  const avatar = currentUser?.patient?.avatar
    ? `${process.env.REACT_APP_BASE_PATH}/files/${currentUser?.patient?.avatar}`
    : "";

  return (
    <>
      <Grid item>
        <ProfileButton
          profile={{
            name:
              currentUser?.patient?.name ??
              currentUser?.patient?.info?.contactEmail ??
              "u",
            avatar: avatar,
          }}
          urls={{ signout: `/signout`, profile: "/profile/me/edit" }}
        />
      </Grid>
    </>
  );
};

export default connect(getUserMe, () => ({}))(withStyles(styles)(Menu));

const extendedStyles = (theme: Theme) =>
  createStyles({
    buttonAvatar: {
      color: theme.palette.neutral.main,
      "&:hover": {
        background: "inherit",
      },
    },
    iconButtonAvatar: {
      padding: 4,
      color: theme.palette.primary.light,
      // overwrite material ui button styles
      "& > :first-child": {
        fontSize: 32,
      },
      [theme.breakpoints.down("sm")]: {
        margin: " 0 10px",
      },
    },
    name: {
      marginLeft: theme.spacing(1),
    },
    layout: {
      display: "flex",
      flexDirection: "row",
      marginLeft: theme.spacing(3),
      alignItems: "center",
    },
    avatar: {
      width: theme.spacing(6),
      height: theme.spacing(6),
      color: theme.palette.primary.light,
      backgroundColor: theme.palette.primary.lightest,
      border: `1px solid ${theme.palette.primary.main}`,
    },
  });

export type WideMenuProps = ReturnType<typeof getUserMe>;

const WideMenu = (p: WideMenuProps) => {
  const { currentUser } = p;
  const name =
    currentUser?.patient?.name ??
    currentUser?.patient?.info?.contactEmail ??
    "Usuário";
  const avatar = currentUser?.patient?.avatar
    ? `${process.env.REACT_APP_BASE_PATH}/files/${currentUser?.patient?.avatar}`
    : "";
  const theme = useTheme();
  const isSmallerScreen = useMediaQuery(theme.breakpoints.down("sm"), {
    noSsr: true,
  });

  return (
    <ProfileButton
      profile={{
        name: name,
        avatar: avatar,
      }}
      component={(p: any) => <StyledComponent small={isSmallerScreen} {...p} />}
      urls={{ signout: `/signout`, profile: "/profile/me/edit" }}
    />
  );
};

const ResponsiveComponent = (
  props: {
    small?: boolean;
    src?: string;
    alt?: string;
    onClick?: (e: any) => void;
  } & WithStyles<typeof extendedStyles>
) => {
  const { small, classes, src, alt, onClick } = props;

  const iconUser = (
    <Avatar className={classes.avatar} alt={alt} src={src}>
      <Icons.User />
    </Avatar>
  );
  if (small) {
    return (
      <IconButton className={classes.iconButtonAvatar} onClick={onClick}>
        {iconUser}
      </IconButton>
    );
  }
  return (
    <Grid item className={classes.layout}>
      {iconUser}
      <Button
        disableRipple
        variant="text"
        endIcon={<Icons.ExpandMore fontSize="large" />}
        classes={{ endIcon: classes.iconButtonAvatar }}
        className={classes.buttonAvatar}
        onClick={onClick}
      >
        <span className={classes.name}>{alt}</span>
      </Button>
    </Grid>
  );
};

const StyledComponent = withStyles(extendedStyles)(ResponsiveComponent);

export const ExtendedMenu = connect(getUserMe, () => ({}))(WideMenu);
